import React from "react";
import { Result, Button } from "antd";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("SuperAdmin ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "40px 16px",
            minHeight: "70vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Result
            status="error"
            title="Something went wrong"
            subTitle={
              this.state.error?.message ||
              "An unexpected error occurred while displaying this page."
            }
            extra={[
              <Button
                type="primary"
                key="reload"
                onClick={() => window.location.reload()}
              >
                Reload Page
              </Button>,
              <Button
                key="dashboard"
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.href = "/crm/admin";
                }}
              >
                Go to Dashboard
              </Button>,
            ]}
          />
        </div>
      );
    }
    return this.props.children;
  }
}

